import React, { useEffect, useState } from 'react'
import websal from '../../assets/logowebsal.png'
import { NavLink } from 'react-router-dom'
import home from '../../assets/sidebar/home-outline.svg'
import pencil from '../../assets/sidebar/pencil-outline.svg'
import { log_out } from '../../store/actions/login.actions'
import { SelectEmpresa } from './SelectEmpresa'
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux'
import edit from '../../assets/sidebar/create-outline.svg'
import { getEmpresas } from '../../store/actions/app.actions'
import { VigentesToggle } from './VigentesToggle'


export const SideBarRepresentantes = () => {

    const [toggleMenu, setToggleMenu] = useState(false)
    const dispatch = useDispatch()
    const empresa  = useSelector(state => state.app.empresa)


    const data     = useSelector(state => state.login.data)
    

   useEffect(() => {
 
    dispatch(getEmpresas(data))


    }, [])
  

    const salir = () => {
        localStorage.clear()
      

        dispatch(log_out())

     }



     const [modalIsOpen, setIsOpen] = useState(false)
     const [detalles, setDetalles] = useState({})
  
  
  
              function openModal(firm) {
                  setIsOpen(true);
                  setDetalles(firm)
          
  
              }
       
              
              function closeModal() {
                  setIsOpen(false);
  
  
              }
              
  
              const customStyles = {
                  content: {
                  top: '18%',
                  padding:'20px',
                  paddingLeft:"40px",
                  paddingRight:"40px",
                  width:"500px",
                  // margin:'0 auto',
                  height:'290px'
                  },
              };
  




  return (
    <div className='contenedorSidebar'>
        
        <div className='contenedorImg' >

  
          <NavLink
                to="/home"
              
              >
                <img src={websal} alt='logo'  />

          </NavLink>
      </div>
             




        <div className='liLateral' >

        <ul className='ulLi'>


        <div onClick={() => openModal() } className='selectEmpresaSidebar'>

              

              <p> { empresa ? empresa.label : 'Selecciona empresa' } </p>
              <img  className='edit' src={edit} alt='ver' />

           

        </div>

                     {
                        empresa.value !== 'Selecciona Empresa'  &&

                        <VigentesToggle/>
                      }

     
{/*       
                        <li>

                                <NavLink
                                    to="/home-representantes"
                                    onClick={() => setToggleMenu(false) }

                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={home} alt='ver' />

                                    Home
                                </NavLink>
                        </li> */}
                         
                        
                         
                                    <li className='firma' >

                                            <NavLink
                                            to="/firma-representantes"
                                            //   onClick={() => setToggleMenu(false) }

                                            className={({ isActive }) =>
                                                isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                            }
                                            >
                                            <img  className='iconos' src={pencil} alt='ver' />

                                            Firma Digital
                                            </NavLink>
                                    </li>
                         

             


                              


        </ul>

   

            
        <button className="salir" style={{marginTop: window.innerHeight > 775 ? '5rem' : '3rem' }} onClick={ salir }  >

              <p>Salir</p>

        </button>


           



        </div>

                           <Modal
                                      isOpen={modalIsOpen}
                                    
                                      onRequestClose={closeModal}
                                      style={customStyles}
                                      contentLabel="Example Modal"
                                      ariaHideApp={false}
                                  >
                                                                                          
                            <div className='contenedorSelectEmpresa'>

                                 <SelectEmpresa/>





                                 <button className='buttonContinuarSelectEmpresa' onClick={closeModal} >Continuar</button>
                                                                                        
                             </div>
                             
                            </Modal>
                       

       
        
        
    </div>
  )
}
